import { bffApi } from "../../../services/bff/bffApi";
import {
  NpsConfiguration,
  NpsConfigurationFilter,
  NpsConfigurationPayload,
} from "../types";

export default class NpsService {
  private readonly configurationsUrl = `/api/struct/v1/nps/configurations`;

  getConfigurations = async (filter: NpsConfigurationFilter) => {
    const response = await bffApi.get<NpsConfiguration[]>(
      this.configurationsUrl,
      { params: filter }
    );
    return response.data ?? [];
  };

  createConfiguration = async (payload: NpsConfigurationPayload) => {
    const response = await bffApi.post<NpsConfiguration>(
      this.configurationsUrl,
      payload
    );
    return response.data;
  };

  updateConfiguration = async (id: number, payload: NpsConfigurationPayload) => {
    const response = await bffApi.put<NpsConfiguration>(
      `${this.configurationsUrl}/${id}`,
      payload
    );
    return response.data;
  };
}
